module.exports = __webpack_public_path__ + "fonts/Origo.woff2";